export const NOTIFICATION_EXPAND_DELAY = 500;
export const NOTIFICATION_DISMISS_DELAY = 8000;
export const DEFAULT_VALUE_ACHIEVEMENTS_POLLING_INTERVAL_MILLISECONDS = 10000;
